"use client";
import React, { Suspense } from "react";
import Image from "next/image";

import Button, { ButtonStyle } from "@mae/components/ui/Button";
import type { IResolvedRelease } from "@mae/misc/discography/types";
import { useSetAtom } from "jotai";
import { transparentNavbar } from "@mae/store/transparentNavbar";

// TODO: make this responsive

export default function Release({ release }: { release: IResolvedRelease }) {
    const setTransparentPage = useSetAtom(transparentNavbar);
    setTransparentPage(true);

    return (
        <div className="overflow-hidden">
            <div className="w-full h-full blur-3xl absolute top-0 left-0 z-10">
                <div className="w-full h-full absolute top-0 left-0 z-20 bg-black opacity-60"></div>
                <Image
                    src={release.album_art}
                    alt=""
                    fill={true}
                    quality={1}
                    className="w-full h-full object-cover object-center"
                    style={{
                        maxWidth: "100%",
                    }}
                />
            </div>
            <div className="z-10 sticky flex justify-center my-16 mx-4 min-h-screen">
                <div className="lg:w-[1024px] w-full space-y-8 mx-4">
                    <div className="flex gap-4">
                        <Suspense
                            fallback={
                                <div
                                    className="bg-slate-600"
                                    style={{ width: 120, height: 120 }}
                                ></div>
                            }
                        >
                            <Image
                                src={release.album_art}
                                quality={90}
                                width="120"
                                height="120"
                                alt="Cover art"
                                className="lg:w-fit h-fit rounded-lg shadow-xl"
                                style={{
                                    maxWidth: "100%",
                                    height: "auto",
                                }}
                            ></Image>
                        </Suspense>
                        <div className="flex flex-col justify-end">
                            <h1 className="text-4xl font-bold mb-2">
                                {release.title}
                            </h1>
                            <h2 className="align-baseline">
                                {release.type} • {release.tracks.length} track
                                {release.tracks.length > 1 && "s"} •{" "}
                                {release.year}
                            </h2>
                        </div>
                    </div>
                    <div className="flex lg:flex-row flex-col gap-2 mt-8">
                        {release.links.bandcamp && (
                            <Button
                                text={release.is_free ? "Free Download" : "Buy"}
                                href={release.links.bandcamp}
                                icon={`bx bx-sm mr-2 ${release.is_free ? "bx-down-arrow-alt" : "bx-money"}`}
                                style={ButtonStyle.Unstyled}
                                className="w-full flex lg:w-1/6 justify-center bg-ctp-mauve text-ctp-base hover:bg-purple-500"
                            />
                        )}
                        {release.links.applemusic && (
                            <Button
                                text="Apple Music"
                                href={release.links.applemusic}
                                icon="bx bxl-apple bx-sm mr-2"
                                style={ButtonStyle.Outline}
                            />
                        )}
                        {release.links.spotify && (
                            <Button
                                text="Spotify"
                                href={release.links.spotify}
                                icon="bx bxl-spotify bx-sm mr-2"
                                style={ButtonStyle.Outline}
                            />
                        )}
                        {release.links.soundcloud && (
                            <Button
                                text="SoundCloud"
                                href={release.links.soundcloud}
                                icon="bx bxl-soundcloud bx-sm mr-2"
                                style={ButtonStyle.Outline}
                            />
                        )}
                        {release.links.youtube && (
                            <Button
                                text="YouTube"
                                href={release.links.youtube}
                                icon="bx bxl-youtube bx-sm mr-2"
                                style={ButtonStyle.Outline}
                            />
                        )}
                    </div>

                    {release.artist_comment && (
                        <div>
                            <h3 className="text-lg font-bold">mae's comment</h3>
                            <p className="italic">"{release.artist_comment}"</p>
                        </div>
                    )}

                    <table className="w-full">
                        <thead>
                            <tr>
                                <th className="w-4"></th>
                                <th>Title</th>
                                <th>Artist</th>
                                <th>Genre</th>
                                <th>Length</th>
                            </tr>
                        </thead>
                        <tbody>
                            {release.tracks.map((track, iterator) => (
                                <tr key={track.id}>
                                    <td>{iterator + 1}.</td>
                                    <td>{track.name}</td>
                                    <td>{track.artists.join(", ")}</td>
                                    <td>{track.genre}</td>
                                    <td>{track.length}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {/* <details className='pb-8'>
            <summary className='bg-[rgba(0,0,0,0.6)] cursor-pointer w-56 px-4 py-2 rounded-lg'>Raw data</summary>
            <p className='transition-all font-mono px-4 py-2 bg-[rgba(0,0,0,0.5)] mt-2 rounded-lg'>
              {JSON.stringify(release, null, 4)}
            </p>
          </details> */}
                </div>
            </div>
        </div>
    );
}
